import Vue from "vue";
import Vuex from "vuex";
import authentication from "@/store/modules/authentication";
import currentUser from "@/store/modules/current-user";
import loading from "@/store/modules/loading";
import client from "@/store/modules/client";
import user from "@/store/modules/user";
import systemConfig from "@/store/modules/system-config";
import pages from '@/store/modules/pages';
import storeSettings from '@/store/modules/store-settings';
import adminSettings from '@/store/modules/admin-settings';
import product from '@/store/modules/product';
import order from '@/store/modules/order';
import blog from '@/store/modules/blog';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    authentication,
    currentUser,
    loading,
    client,
    user,
    systemConfig,
    pages,
    shopSettings: storeSettings,
    adminSettings,
    product,
    order,
    blog
  }
});
